import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { mainApi } from "../../api/axios";

// Fetch menu items
export const getMenuItems = createAsyncThunk(
  "menu/getMenuItems",
  async ({ storeId }, { rejectWithValue }) => {
    try {
      const res = await mainApi.get(`/v1/pos/products?store_id=${storeId}`);
      return res.data?.categories || [];
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

// Slice
const menuSlice = createSlice({
  name: "menu",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {
    hydrateMenu: (state, action) => {
      state.items = action.payload || [];
    },
    clearMenu(state) {
      state.items = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMenuItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMenuItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(getMenuItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { hydrateMenu, clearMenu } = menuSlice.actions;
export default menuSlice.reducer;
